import { render } from "./FormattedDateTime.vue?vue&type=template&id=86851c3c"
import script from "./FormattedDateTime.vue?vue&type=script&lang=js"
export * from "./FormattedDateTime.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__